<template>
  <w-icon-wrapper icon-name='work-not-in-sync-icon'>
    <g
      id='_38_Nicht_Synchron_Icon'
      data-name='38 Nicht Synchron_Icon'
      transform='translate(0 0)'
    >
      <path
        id='Pfad_55718'
        d='M9.79,21.75A9.664,9.664,0,0,1,5.2,19.31H6.82a1,1,0,0,0,0-2H1.62v5.2a1,1,0,1,0,2,0V20.58a11.947,11.947,0,0,0,3.93,2.57,12.1,12.1,0,0,0,1.8.55,11.963,11.963,0,0,0,8.74-1.37l-1.47-1.47A9.979,9.979,0,0,1,9.79,21.75Z'
        data-name='Pfad 55718'
        fill='currentColor'
      />
      <path
        id='Pfad_55719'
        d='M2.25,9.8a10.286,10.286,0,0,1,.89-2.42L1.67,5.91A11.794,11.794,0,0,0,.3,9.35,11.959,11.959,0,0,0,.17,14H2.2A9.92,9.92,0,0,1,2.25,9.8Z'
        data-name='Pfad 55719'
        fill='currentColor'
      />
      <path
        id='Pfad_55720'
        d='M23.707,22.293l-2.559-2.559A11.837,11.837,0,0,0,23.7,14.65,11.959,11.959,0,0,0,23.83,10H21.8a9.92,9.92,0,0,1-.05,4.2,9.793,9.793,0,0,1-2.027,4.109L5.691,4.277A9.93,9.93,0,0,1,14.21,2.25,9.664,9.664,0,0,1,18.8,4.69H17.18a1,1,0,0,0,0,2h5.2V1.49a1,1,0,0,0-2,0V3.42A11.947,11.947,0,0,0,16.45.85,12.1,12.1,0,0,0,14.65.3,11.933,11.933,0,0,0,4.281,2.867L1.707.293A1,1,0,0,0,.293,1.707l22,22a1,1,0,0,0,1.414-1.414Z'
        data-name='Pfad 55720'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNotInSync' };
</script>
